module.exports = __webpack_public_path__ + "static/media/chilly_alamy.86a4692c.jpg";